import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconXSquare = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--x-square")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M5,4 C4.44771525,4 4,4.44771525 4,5 L4,19 C4,19.5522847 4.44771525,20 5,20 L19,20 C19.5522847,20 20,19.5522847 20,19 L20,5 C20,4.44771525 19.5522847,4 19,4 L5,4 Z M19,2 C20.6568542,2 22,3.34314575 22,5 L22,19 C22,20.6568542 20.6568542,22 19,22 L5,22 C3.34314575,22 2,20.6568542 2,19 L2,5 C2,3.34314575 3.34314575,2 5,2 L19,2 Z M8.29289322,8.29289322 C7.90236893,8.68341751 7.90236893,9.31658249 8.29289322,9.70710678 L10.5857864,12 L8.29289322,14.2928932 C7.90236893,14.6834175 7.90236893,15.3165825 8.29289322,15.7071068 C8.68341751,16.0976311 9.31658249,16.0976311 9.70710678,15.7071068 L12,13.4142136 L14.2928932,15.7071068 C14.6834175,16.0976311 15.3165825,16.0976311 15.7071068,15.7071068 C16.0976311,15.3165825 16.0976311,14.6834175 15.7071068,14.2928932 L13.4142136,12 L15.7071068,9.70710678 C16.0976311,9.31658249 16.0976311,8.68341751 15.7071068,8.29289322 C15.3165825,7.90236893 14.6834175,7.90236893 14.2928932,8.29289322 L12,10.5857864 L9.70710678,8.29289322 C9.31658249,7.90236893 8.68341751,7.90236893 8.29289322,8.29289322 Z" id="icon--centivo--x-square"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-978.000000, -1423.000000)"/>
          <g id="Icon/x-square">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--x-square"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--x-square"/>
          </g>
      </g>
  </IconWrapper>
)
